import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_authenticated/$slug/fleet/$aircraftId/_aircraft/documents",
)({
  staticData: { title: "Documents" },
  component: lazyRouteComponent(
    () => import("#pages/authenticated/fleet/[aircraftId]/documents/documents.tsx"),
    "Documents",
  ),
})
